// /spaces/{space_id}/entries/{entry_id}/archived



const processError = require('./error-process');

module.exports = (entry) => {
  const needsUnarchiving = entry.sys.archivedAt;

  if (!needsUnarchiving) {
    return Promise.resolve(entry);
  }

  return entry.unarchive().catch(
    processError
  );
};
